import useTrendingList from "./useTrendingList.hook";

export { useTrendingList }